import { useCallback } from "react";
import { useWeb3React, UnsupportedChainIdError } from "@web3-react/core";
import { useToast } from "../state/hooks";
import { connectorsByName } from "../utils/web3React";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";

const useAuth = () => {
  const { toastError } = useToast();
  const chainId = parseInt(process.env.REACT_APP_CHAIN_ID, 10);

  const TomiPayBol = localStorage.getItem("IsTomipay");

  const login = async (connectorID) => {
    const connector = connectorsByName[connectorID];
    if (connector) {
      // console.log("connector??????", connector)
      if (connectorID === "injected") {
        await connector.activate(chainId);
      } else {
        await connector.activate();
        // if (TomiPayBol == 'false') {
        //   console.log("here i trust", connector)
        //   await connector.activate()
        // } else {
        //   console.log("here i tomi ", connector)
        //   setTimeout(async () => {
        //     let ab = await connector?.provider?.signer?.uri
        //     console.log("providerNullproviderNullproviderNull", ab)
        //     // alert(ab)
        //     if (ab == undefined) {
        //       localStorage.setItem('provider', 'true');
        //     }
        //     else {
        //       localStorage.setItem('provider', 'false');
        //     }
        //     // alert(ab)
        //     window["ReactNativeWebView"] && window["ReactNativeWebView"].postMessage(ab);
        //   }, 3000)
      }
    } else {
      toastError("Can't find connector", "The connector config is wrong");
    }
  };

  // const logout = async (connectorID) => {
  //   // console.log("disssss", connectorID)
  //   const connector = connectorsByName[connectorID];
  //   // console.log("disssss", connector)
  //   if (connector) {
  //     if (connector?.deactivate) {
  //       await connector.deactivate();
  //     } else {
  //       await connector.resetState();
  //     }
  //     // await connector.deactivate()
  //   } else {
  //     toastError("Can't find connector", "The connector config is wrong");
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // };

  const logout = async (connectorID) => {
    const connector = connectorsByName[connectorID];
    console.log("connectorconnectorconnector", connectorID);

    if (connector) {
      try {
        // 🛑 Handle WalletConnect separately
        if (connectorID === "walletconnect") {
          await connector.deactivate();
          console.log("WalletConnect session closed");
        }

        // 🛑 Handle MetaMask
        if (connectorID === "injected") {
          if (window.ethereum) {
            try {
              await window.ethereum.request({
                method: "wallet_revokePermissions",
                params: [{ eth_accounts: {} }],
              });
              console.log("MetaMask permissions revoked");
            } catch (error) {
              console.warn("Error revoking MetaMask permissions:", error);
            }
          }
        }

        // Reset connector state for both MetaMask & WalletConnect
        await connector.resetState();

        // Clear localStorage cache
        if (typeof window !== "undefined") {
          window.localStorage.removeItem("walletconnect"); // WalletConnect v1
          window.localStorage.removeItem("walletconnect.next"); // WalletConnect v2
          window.localStorage.removeItem("WEB3_CONNECT_CACHED_PROVIDER"); // Web3Modal
          window.localStorage.removeItem("connectedWallet"); // Custom storage keys
        }

        // Small delay before reloading the page
        // setTimeout(() => window.location.reload(), 500);
      } catch (error) {
        console.error("Error disconnecting:", error);
      }
    } else {
      toastError("Can't find connector", "The connector config is wrong");
    }
  };

  return { login, logout };
};

export default useAuth;
